// Drawing units (AutoCAD UNITS + SCALE → Reference). Shown after upload so every stage —
// Modal, the classify-agent pre-clean and the architect review — runs at the true scale.
import { IconClose, IconWarningTriangle } from './shared/assets/icons'
import { PLAUSIBLE_M, UNIT_OPTIONS, sameScale } from './uploadUnits'

export default function DrawingUnitsDialog({ cmPerUnit, size, onUnitChange, onScaleByReference, onConfirm, onClose }) {
  const current = UNIT_OPTIONS.find(o => sameScale(o.cm, cmPerUnit))
  const longest = size ? Math.max(size.w, size.h) : null
  const implausible = longest != null && (longest < PLAUSIBLE_M[0] || longest > PLAUSIBLE_M[1])
  return (
    <div className="scale-dialog-overlay" onClick={onClose}>
      <div className="scale-dialog units-dialog" role="dialog" aria-label="Drawing units" onClick={e => e.stopPropagation()}>
        <div className="scale-dialog-header">
          <span>Drawing units</span>
          <button className="icon-btn" onClick={onClose} aria-label="Close"><IconClose /></button>
        </div>
        <div className="scale-dialog-row">
          <label htmlFor="units-select">Units:</label>
          <select id="units-select" className="scale-dialog-select" value={current?.label ?? 'custom'}
            onChange={e => onUnitChange(UNIT_OPTIONS.find(o => o.label === e.target.value).cm)}>
            {!current && <option value="custom">Custom ({cmPerUnit.toPrecision(3)} cm per unit)</option>}
            {UNIT_OPTIONS.map(o => <option key={o.label} value={o.label}>{o.label}</option>)}
          </select>
        </div>
        <p className={`units-size ${implausible ? 'warn' : ''}`}>
          {implausible && <IconWarningTriangle width="14" height="14" />}
          Plan size: <strong>{size ? `${size.w.toFixed(1)} × ${size.h.toFixed(1)} m` : '—'}</strong>
        </p>
        {implausible && (
          <p className="scale-dialog-hint units-warn-text">
            Real floors are usually {PLAUSIBLE_M[0]}–{PLAUSIBLE_M[1]} m across. Check the units, or scale by a
            length you know (a door, a column grid).
          </p>
        )}
        <div className="units-actions">
          <button className="btn btn-sm units-ref-btn" onClick={onScaleByReference}>Scale by reference…</button>
          <button className="btn btn-primary btn-sm" onClick={onConfirm} autoFocus>OK</button>
        </div>
      </div>
    </div>
  )
}
